module.exports = __webpack_public_path__ + "img/电表.dc3226cf.png";